import React, {useEffect, useMemo, useState} from "react";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import useDeliveryType from "src/core/deliveries/hooks/useDeliveryType";

export const IdentityVerificationModalWrapper = ({...props}) => {
  const [{loading}, authApi] = useAuthentication();
  const userProfile = authApi.userProfile();
  const [deliveryType] = useDeliveryType();

  const [status, setStatus] = useState();

  const identityVerification =
    authApi.isLoggedIn() && userProfile
      ? userProfile.getIdentityVerification(deliveryType?.code)
      : null;

  const value = useMemo(() => {
    if (!identityVerification) return {};
    return identityVerification.getVerificationData(deliveryType, status);
  }, [deliveryType, identityVerification, status]);

  useEffect(() => {
    if (!loading && identityVerification) {
      identityVerification
        .getIdVerificationStatus()
        .then((response) => setStatus(response.status))
        .catch(() => setStatus(undefined));
    }
    // eslint-disable-next-line
  }, [identityVerification, loading]);

  return (
    <IdVerificationContext.Provider value={value}>
      {props.children}
    </IdVerificationContext.Provider>
  );
};

export const IdVerificationContext = React.createContext({});
